<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.TITLE' | translate }}
      <span *ngIf="openTicketsCount !== undefined">({{ openTicketsCount }})</span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-container>
    <button mat-stroked-button color="primary" class="card-button" (click)="openCreateTicket()">
      {{ 'CRM.ASSOCIATION_PANEL.TICKETS.ACTIONS.CREATE' | translate }}
    </button>
    <app-support-ticket-list
      [partner]="partnerId$ | async"
      [title]="'CRM.ASSOCIATION_PANEL.TICKETS.OPEN_TICKETS' | translate"
      [status]="'open'"
      (ticketsCount)="openTicketsCount = $event"
    ></app-support-ticket-list>
  </ng-container>
</mat-expansion-panel>
